let getBodyDimensions = () => {
  return document.querySelector('body').getBoundingClientRect()
}

let closestEl = (el, search) => {
  let node = el
  while (node) {
    if (node.matches(search)) {
      return node
    }
    node = node.parentNode
  }
}

let addScript = src => {
  const s = document.createElement('script')
  s.setAttribute('src', src)
  document.head.appendChild(s)
  let p = new Promise(resolve => {
    s.onload = () => {
      resolve()
    }
  })

  return p
}

let nl2br = text => {
  return (text || '').replace(/\n/gm, '<br/>')
}

let truncate = (text, len, append) => {
  append = append || '...'

  if ((text || '').length <= len) {
    return text
  }

  return text.substring(0, len - 1) + append
}

let moneyFormat = (number, fractionPlaces, currency) => {
  return number.toLocaleString('en-GB', {
    style: 'currency',
    currency: currency || 'GBP',
    minimumFractionDigits: fractionPlaces || 0
  })
}

export {
  getBodyDimensions,
  closestEl,
  addScript,
  nl2br,
  truncate,
  moneyFormat
}
